import _ from "underscore";
export const encode = (request) => _.reduce(request, (parameters, item, key) => _.extend(parameters, {
    [key]: _.isArray(item) ? item.join(",") : item,
}), {});
